
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import BannerCarousel from "../components/BannerCarousel";
import CategorySlider from "../components/CategorySlider";
import ProductSection from "../components/ProductSection";
import AboutCompanySection from "../components/AboutCompanySection";

import premium from "../assest/products/extra/premium.jpg";
import acer from "../assest/products/extra/acer.jpg";
import TopBrands from "../components/TopBrands";
import TrustSection from "../components/TrustSection";
import SaleBanner from "../components/SaleBanner";
import TopMarqueePremium from "../components/TopMarqueePremium";
import { SwiperSlide } from "swiper/react";

const Home = () => {

  const navigate = useNavigate();
  // const [data, setData] = useState([]);

  const handleClick = () => {
    navigate("/search?minPrice=30000");
  };

  // useEffect(() => {
  //   const fetchProducts = async () => {
  //     const res = await fetch("https://lappyshop.onrender.com/api/get-product");
  //     const result = await res.json();
  //     if (result.success) {
  //       setData(result.data);
  //     }
  //   };
  //   fetchProducts();
  // }, []);

  const brandsData = [
    { name: "dell", img: "/images/dell.jpg" },
    { name: "hp", img: "/images/hp.jpg" },
    { name: "lenovo", img: "/images/lenovo.jpg" },
    { name: "asus", img: "/images/asus.jpg" },
    { name: "apple", img: "/images/apple.jpg" },
    { name: "acer", img: acer },
  ];

  return (
    <div className="bg-[#f5f7fb] pb-4">
<TopMarqueePremium/>
      {/* 🔥 HERO BANNER */}
      <div className="max-w-8xl mx-auto px-4 pt-2">
        <div className="rounded-md overflow-hidden shadow">
          <BannerCarousel />
        </div>
      </div>

      {/* 🔥 FEATURES */}
      <TrustSection/>
      <SaleBanner/>
      
      {/* <div className="max-w-7xl mx-auto px-4 mt-10">
        <ProductSection />
      </div> */}
 

      {/* 🔥 CATEGORY */}
      <div className="max-w-8xl mx-auto px-4 mt-6">
        <div className="bg-gray-100 rounded-md shadow p-4">
          <CategorySlider />
        </div>
      </div>

      {/* 🔥 DEAL + PRODUCTS */}
      {/* <div className="max-w-7xl mx-auto px-4 mt-6">
        <div className="bg-white rounded-2xl shadow p-4">
          {data.map((product) => (
          <SwiperSlide key={product._id}> 
          <ProductSection product={product}/>
          </SwiperSlide>
))}
        </div>
      </div> */}
      <div className="max-w-8xl mx-auto px-4 mt-6">
        <div className="bg-white rounded-2xl shadow p-4">
<ProductSection/>
        </div>
      </div>
        <TopBrands brands={brandsData}/>

      {/* 🔥 PROMO BANNER */}
      <div className="max-w-7xl mx-auto px-4 mt-8">

        <motion.div
          whileHover={{ scale: 1.01 }}
          onClick={handleClick}
          className="relative rounded-2xl overflow-hidden cursor-pointer shadow-lg"
        >

          <img
            src={premium}
            className="w-full h-[180px] md:h-[300px] object-cover"
          />

          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent" />

          <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-12 text-white">

            <h2 className="text-xl md:text-4xl font-bold">
              Its Time to Celebrate
            </h2>

            <p className="text-lg md:text-2xl font-semibold mt-1">
              40% DISCOUNT
            </p>

            <button className="mt-4 bg-white text-black px-5 py-2 rounded-full w-fit font-medium">
              Shop Fast & Easy →
            </button>

          </div>

        </motion.div>

      </div>
      <div className="mt-12">
        <AboutCompanySection />
      </div>

    </div>
  );
};

export default Home;